export const compareVersions = (a: string, b: string): -1 | 0 | 1 => {
  const partsA = a.split('.').map(Number);
  const partsB = b.split('.').map(Number);
  const len = Math.max(partsA.length, partsB.length);
  for (let i = 0; i < len; i++) {
    const segA = partsA[i] || 0;
    const segB = partsB[i] || 0;
    if (segA > segB) return 1;
    if (segA < segB) return -1;
  }
  return 0;
};
